import type { SVGProps } from "react";

export function IconGrayOne(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="56" height="56" rx="28" fill="#F7F8FE" />
      <path
        d="M27.9033 37V23.392L23.8953 25.456V22.744L28.4073 20.44H30.6873V37H27.9033Z"
        fill="#1C1719"
      />
    </svg>
  );
}
